import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import DownloadwithDisplayProper from "../../../../Common/FilesRelevent/DownloadwithDisplayProper";
import GetPrice from "../../../MyOrders/MyOrders/PostedOrders/PostedProjects/MineActiveProject/ProjectModels/GetPrice";
import ProfilePic from "../../../../../assests/imgs/Profileplaceholder.svg";
import CustomReactQuillDescription from "../../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";



export default function ManageAppliedProjectProposal({ pd, posts }) {
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const path = "Assets/scss/FindWork.module.scss";

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, []);

  return (
    <div className="project-details project-section p-0">
      <div className="post-details">
        <div className="proposal-left">
          <img src={pd?.profile_image ? pd?.profile_image : ProfilePic} alt="" width={30} height={30} />
          <div>
            <h5>
              {pd?.first_name} {pd?.last_name}
              <span>
                <i className="fa-solid fa-star"></i> {pd?.expert_rating || 0} (
                {pd?.expert_comment_count || 0} reviews)
              </span>
            </h5>
            <p>{pd?.designation}</p>
            {/* <h6> {pd?.price_per_hour == 0 ? `` : `$ ${formatNumberWithCommas(pd?.price_per_hour)}/hr`} {pd?.price_per_month == 0 ? `` : `$ ${formatNumberWithCommas(pd?.price_per_month)}/month`}</h6> */}
          </div>
          {
            pd?.status == 22 &&
            <div className="">
              <button
                className="border-button buttons"
              >
                <span>Offer Declined</span>
              </button>
            </div>
          }
        </div>
        <div className="lang-sec">
          <h4>Proposal Details</h4>
          <h6>Cover letter</h6>
          <CustomReactQuillDescription value={pd?.message} displyreadorless={true} key={pd?.id} />
        </div>
        <div className="dollar-sec">
          <div>
            <h6>Propose price</h6>

            <p>
              {/* <img
              src={`${CloudStorage.cloudurl}/Assets/Images/project/dollar.svg`}
              alt=""
            /> */}
              <GetPrice
                type={posts?.type}
                price={pd?.price}
                hiring_type={posts?.hiring_type}
              />
            </p>
          </div>
        </div>
        <div className="lang-sec">
          <h6>Competencies</h6>
          <div className="photoshop">
            {Array.isArray(pd?.skills) &&
              pd?.skills.map((item1, index1) => (
                <p key={index1}>{item1.title}</p>
              ))}
          </div>
        </div>
        {Array.isArray(pd?.files) && pd?.files && pd?.files?.length > 0 && (
          <div className="lang-sec">
            <h6>Attachments</h6>
            <div className="images">
              {pd?.files &&
                Array.isArray(pd?.files) &&
                pd?.files.map((item, index) => (
                  <DownloadwithDisplayProper item={item} />
                ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
